const COLLECTIONS = {
  USERS: "users",
  PRODUCTS: "products",
  CATEGORIES: "categories",
  ORDERS: "orders",
  CART: "cart",
};

const ORDER_STATUS = {
  PENDING: "Pending",
  PROCESSING: "Processing",
  DELIVERED: "Delivered",
};

export { COLLECTIONS, ORDER_STATUS };
export default COLLECTIONS;
